<template>
  <div :class="className" :style="{height: height,width: width}" />
</template>
<script>

import * as echarts from 'echarts'
require('echarts/theme/macarons')
import resize from '@/mixins/resize'

export default {
  components: {},
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '9rem'
    },
    colorData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      chart: null,
    }
  },
  created() {
    
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    getLineData(data, date) {
      
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions()
    },
    setOptions({ expectedData, actualData } = {}) {
      this.chart.setOption({
        title: {
          show: false,
          text: '暂无数据',
          left: 'center',
          top: 'center',
          textStyle: {
            color: '#909399',
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#FFFFFF'
            }
          },
          backgroundColor: '#FFFFFF'
        },
        toolbox: {
        },
        legend: {
          data: [
            {icon:'circle',name:'评论数'}, 
            {icon:'circle',name:'NWR'}, 
          ],
          left: 'left',
          itemWidth: 10,
          textStyle: {
            color: '#000',
            fontSize: 16
          },
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '1%',
          top: '25%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['2019-01', '2019-02', '2019-03'],
            axisPointer: {
              type: 'shadow'
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#000',
              fontSize: 16
            },
            axisLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            nameLocation:'left',
            nameTextStyle:{
              color: '#000',
              fontSize:14,
              padding:[0,120,-30,0]
            },
            min: 0,
            max: 100,
            interval: 50,
            axisLabel: {
              color: '#000',
              fontSize: 16
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dotted',
                color: '#000'
              },
              textStyle: {
                color: '#000'
              }
            },
            axisTick: {
              show: false,
            },  
            axisLine:{
              show:false
            },
            splitArea : {
              show : false
            },
          },
        ],
        color: ['#262A76', '#FFBB00'],
        series: [
          {
            name: '评论数',
            type: 'bar',
            barWidth: 18,
            data: [30, 100, 80]
          },
          {
            name: 'NWR',
            type: 'line',
            smooth: false,
            data: [20, 100, 60]
          }
        ]
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/voc/cmetanalys/components/LineHistChart.vue